import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const SCUnorderedList = styled.ul`
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-left: ${props => (props.noPadding ? 0 : '20px')};
  padding-left: 0;
  margin-bottom: 0;
  list-style-type: ${props => (props.showBullets ? 'circle' : 'none')};
  ${props =>
    props.isInline &&
    css`
      flex-direction: row;
      flex-wrap: wrap;
      list-style-type: none;
      margin: 0;
      padding: 0;

      > li {
        margin-left: 22px;
      }
    `};
`;

const List = props => {
  if (props.isOrdered) {
    return <ol className={props.className}>{props.children}</ol>;
  } else {
    return (
      <SCUnorderedList
        isInline={props.isInline}
        showBullets={props.showBullets}
        className={props.className}
        noPadding={props.noPadding}
      >
        {props.children}
      </SCUnorderedList>
    );
  }
};

List.defaultProps = {
  isOrdered: false
};

List.propTypes = {
  /** Display ordered list or unordered list */
  children: PropTypes.node,
  /** Extra class to apply to element */
  className: PropTypes.string,
  /** Render an ordered list */
  isOrdered: PropTypes.bool,
  /** Render list inline */
  isInline: PropTypes.bool,
  /** Render bullets */
  showBullets: PropTypes.bool,
  /** Remove padding */
  noPadding: PropTypes.bool
};

export default List;
